"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SeedOfDarknessAbilityHandler = exports.SeedOfDarknessActorAbilityFactory = exports.SeedOfDarknessAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const core_1 = require("../../core/effects/core");
const Duration_1 = require("../../core/Duration");
const core_2 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class SeedOfDarknessAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.SeedOfDarkness;
        this.__typeName = "SeedOfDarkness";
    }
}
exports.SeedOfDarknessAbilityArgs = SeedOfDarknessAbilityArgs;
let SeedOfDarknessActorAbilityFactory = class SeedOfDarknessActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("SeedOfDarkness", "OneEnemies", 3);
    }
};
SeedOfDarknessActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("SeedOfDarkness")
], SeedOfDarknessActorAbilityFactory);
exports.SeedOfDarknessActorAbilityFactory = SeedOfDarknessActorAbilityFactory;
let SeedOfDarknessAbilityHandler = class SeedOfDarknessAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [targetId] = ability.args.target.actorIds;
        container.applyAttackWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "magic",
            attackerId: ability.invokerId,
            targetId,
            toApply: [
                AbilityDamage_1.AbilityDamage.Focus("Death", 80)
            ],
            onHit(sequence) {
                container.applyDebuff({
                    attackerId: ability.invokerId,
                    targetId,
                    effect: new core_1.SeedOfDarknessEffectArgs(),
                    duration: Duration_1.Duration.Ticks(8),
                    sequence,
                    onApplied(sequence) {
                        sequence.push(new core_2.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(targetId, "feet", "behind"), "DarkMagicCircle"));
                        const ruinated = container.readLocal(ability.invokerId, "Ruination_AppliedToId", 0);
                        if (ruinated > 0) {
                            container.applyAttackDamage({
                                attackType: "magic_tick",
                                attackerId: ability.invokerId,
                                targetId: ruinated,
                                isCrit: false,
                                toApply: AbilityDamage_1.AbilityDamage.Focus("Death", 100),
                                sequence
                            });
                        }
                    }
                });
            }
        });
    }
};
SeedOfDarknessAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.SeedOfDarkness)
], SeedOfDarknessAbilityHandler);
exports.SeedOfDarknessAbilityHandler = SeedOfDarknessAbilityHandler;
